/* eslint-disable */
export default {
    questionnairebuilder_page_title: "Questionnaire builder",
    questionnairebuilder_load_error: "Something went wrong while loading the content",
    questionnairebuilder_en_GB: "English",
    questionnairebuilder_nl_NL: "Dutch",
    questionnairebuilder_unsaved_changes: "There are unsaved changes",
    questionnairebuilder_all_changes_saved: "All changes are saved",
    questionnairebuilder_save_button: "Save",
    questionnairebuilder_save_error: "Something went wrong while saving",
    questionnairebuilder_section_title_question: "Question",
    questionnairebuilder_section_title_choices: "Answer options",
    questionnairebuilder_section_title_feedback: "Feedback",
    questionnairebuilder_key_used_in: "This translation is used in",
    questionnairebuilder_de_DE: "German",
    questionnairebuilder_fr_FR: "French"
};
